import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'languageFlagIcon',
  // eslint-disable-next-line
  standalone: false,
})
export class LanguageFlagIconPipe implements PipeTransform {
  constructor() {}

  transform(langCode?: string): string {
    if (!langCode) {
      return 'flag-icon-de';
    }

    if (langCode === 'en') {
      return 'flag-icon-gb';
    }

    if (langCode === 'uk') {
      return 'flag-icon-ua';
    }

    return `flag-icon-${langCode}`;
  }
}
